<template>
  <b-form ref="scaleForm" @submit="onSubmit" @reset="onReset" class="needs-validation">
    <b-form-row>
      <b-col lg="8">
      <b-form-group id="langGrup">
        <span :class="'flagItem flag-icon flag-icon-' + currentScaleContent.countryCode"></span>
      </b-form-group>

      <b-form-group id="scaleName">
        <span class="fieldHeader">{{$t('name')}}:</span>
        <b-form-input id="nameInput"
                      type="text"
                      v-model.trim="currentScaleContent.name"
                      required
                      :state="stateName">
        </b-form-input>
        <template slot="invalid-feedback">
          {{feedbackName}}
        </template>
      </b-form-group>

      <b-form-group id="LowEndDescription"
                    :label="$t('privatePage.lowEndDescription')"
                    label-for="LowEndDescription">
        <b-form-input id="LowEndDescriptionInput"
                      type="text"
                      v-model="currentScaleContent.lowEndDescription">
        </b-form-input>
      </b-form-group>

      <b-form-group id="HighEndDescription"
                    :label="$t('privatePage.highEndDescription')"
                    label-for="HighEndDescription">
        <b-form-input id="HighEndDescriptionInput"
                      type="text"
                      v-model="currentScaleContent.highEndDescription">
        </b-form-input>
      </b-form-group>

      <b-form-group id="LowEndCoachingDescription"
                    :label="$t('privatePage.lowEndCoachingDescription')"
                    label-for="LowEndCoachingDescription">
        <b-form-input id="LowEndCoachingDescriptionInput"
                      type="text"
                      v-model="currentScaleContent.lowEndCoachingDescription">
        </b-form-input>
      </b-form-group>

      <b-form-group id="HighEndCoachingDescription"
                    :label="$t('privatePage.highEndCoachingDescription')"
                    label-for="HighEndCoachingDescription">
        <b-form-input id="HighEndCoachingDescription"
                      type="text"
                      v-model="currentScaleContent.highEndCoachingDescription">
        </b-form-input>
      </b-form-group>

      <b-form-group>
        <b-button type="submit">{{ $t('save') }}</b-button>
        <b-button type="reset">{{ $t('cancel') }}</b-button>
      </b-form-group>
      <b-form-group>
        <b-alert v-model="alerts.countdown"
                dismissible
                :variant="alerts.variant"
                @closed="alerts.countdown=0"
                @close-count-down="countDownChanged">
          {{alerts.message}}
        </b-alert>
      </b-form-group>
      </b-col>
    </b-form-row>
  </b-form>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'scale-lang-detail-editor',
  computed: {
    ...mapGetters('scalesModule', [
      'currentScaleContent',
      'isEditingScaleContent'
    ]),
    ...mapGetters(['languages']),
    stateName() {
      if (this.currentScaleContent && this.currentScaleContent.name) {
        return this.currentScaleContent.name.length > 0
      }
      return false
    },
    feedbackName() {
      return this.$t('name_required_feedback')
    },
    submitMessage() {
      return this.$t('save_ok_feedback')
    }
  },
  methods: {
    ...mapActions('scalesModule', {
      saveScaleDetails: 'saveScaleDetails',
      selectCurrentScaleContent: 'selectCurrentScaleContent',
      setIsEditingScaleContent: 'setIsEditingScaleContent'
    }),
    onSubmit: function(evt) {
      if (this.validateForm()) {
        evt.preventDefault()
        this.saveScaleDetails()
          .then(() => {
            this.showSuccessMessage(this.submitMessage)
          })
          .catch(error => {
            this.showErrorMessage(error)
          })
      } else {
      }
    },
    onReset: function(evt) {
      evt.preventDefault()
      this.selectCurrentScaleContent({})
      this.setIsEditingScaleContent(false)
    },
    validateForm: function() {
      return (
        !(
          this.currentScaleContent.name === undefined ||
          this.currentScaleContent.name === ''
        ) && this.currentScale.questionFormatId !== undefined
      )
    },
    countDownChanged: function(dismissCountDown) {
      this.alerts.countdown = dismissCountDown
    },
    showMessage: function(message) {
      this.alerts.message = message
      this.alerts.countdown = this.alerts.dismissSecs
      this.alerts.variant = 'info'
    },
    showErrorMessage: function(message) {
      this.alerts.message = message
      this.alerts.countdown = this.alerts.dismissSecs
      this.alerts.variant = 'danger'
    },
    showSuccessMessage: function(message) {
      this.alerts.message = message
      this.alerts.countdown = this.alerts.dismissSecs
      this.alerts.variant = 'success'
    }
  },
  data() {
    return {
      alerts: {
        dismissSecs: 3,
        countdown: 0,
        message: '',
        variant: 'warning'
      }
    }
  },
  props: {
    currentScale: {}
  }
}
</script>
